(() => {
  const checkboxSelector = '#gift-wrap-checkbox';
  const giftWrapHandle = 'gift-wrap';
  const giftWrapTitle = 'gift wrap';
  const giftWrapVariantId = 53013065597237;
  const giftWrapVariantIdString = String(giftWrapVariantId);
  const attributeName = 'Gift wrap';
  const enabledValue = 'Yes';
  const routesRoot = window.Shopify?.routes?.root || '/';

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function getCheckbox() {
    return document.querySelector(checkboxSelector);
  }

  function isGiftWrapItem(item) {
    if (!item) return false;
    const url = normalize(item.url);
    const handle = normalize(item.handle);
    const productHandle = normalize(item.product_handle);
    const title = normalize(item.product_title || item.title);

    return (
      item.variant_id === giftWrapVariantId ||
      handle === giftWrapHandle ||
      productHandle === giftWrapHandle ||
      url.includes(`/products/${giftWrapHandle}`) ||
      title === giftWrapTitle
    );
  }

  function getGiftWrapItem(cart) {
    return cart.items.find(isGiftWrapItem);
  }

  function getGiftWrapItems(cart) {
    return cart.items.filter(isGiftWrapItem);
  }

  function hasPurchasableItems(cart) {
    return cart.items.some((item) => !isGiftWrapItem(item) && item.quantity > 0);
  }

  function getPurchasableItemCount(cart) {
    return cart.items.reduce((count, item) => (isGiftWrapItem(item) ? count : count + item.quantity), 0);
  }

  function updateCartBubble(count) {
    document.querySelectorAll('[data-testid="cart-bubble"], .cart-bubble__text-count').forEach((element) => {
      element.textContent = count > 0 ? String(count) : '';
      element.classList.toggle('hidden', count <= 0);
    });

    document.querySelectorAll('.cart-bubble').forEach((bubble) => {
      bubble.classList.toggle('visually-hidden', count <= 0);
    });
  }

  function getGiftWrapRows() {
    const rows = new Set();
    document.querySelectorAll(`[data-variant-id="${giftWrapVariantIdString}"], [href*="/products/${giftWrapHandle}"]`).forEach((element) => {
      const row = element.closest('tr, .cart-item, .cart-items__table-row');
      if (row instanceof HTMLElement) rows.add(row);
    });

    document.querySelectorAll('.cart-items__title').forEach((title) => {
      if (normalize(title.textContent) === giftWrapTitle) {
        const row = title.closest('tr, .cart-item, .cart-items__table-row');
        if (row instanceof HTMLElement) rows.add(row);
      }
    });

    return Array.from(rows);
  }

  function lockGiftWrapQuantityControls() {
    getGiftWrapRows().forEach((row) => {
      row.dataset.giftWrapLine = 'true';

      row.querySelectorAll('.gift-wrap-fixed-quantity').forEach((fixedQuantity) => fixedQuantity.remove());
      row.querySelectorAll('[headers="quantity"], .cart-items__quantity, .cart-item__quantity').forEach((quantityCell) => {
        quantityCell.setAttribute('aria-hidden', 'true');
        if (quantityCell instanceof HTMLElement) {
          quantityCell.hidden = false;
          quantityCell.style.visibility = 'hidden';
          quantityCell.style.pointerEvents = 'none';
        }
      });

      row.querySelectorAll('quantity-selector-component, cart-quantity-selector-component, .quantity-selector').forEach((selector) => {
        selector.setAttribute('aria-hidden', 'true');
        if (selector instanceof HTMLElement) selector.hidden = true;
        selector.querySelectorAll('button, input').forEach((control) => {
          control.disabled = true;
          control.setAttribute('tabindex', '-1');
        });
      });

      row.querySelectorAll('.cart-items__remove, [href*="quantity=0"], button[name="updates[]"][value="0"]').forEach((removeControl) => {
        removeControl.setAttribute('aria-hidden', 'true');
        if (removeControl instanceof HTMLElement) removeControl.hidden = true;
        if ('disabled' in removeControl) removeControl.disabled = true;
        removeControl.setAttribute('tabindex', '-1');
      });
    });
  }

  function injectGiftWrapStyles() {
    if (document.getElementById('gift-wrap-cart-styles')) return;

    const style = document.createElement('style');
    style.id = 'gift-wrap-cart-styles';
    style.textContent = `
      [data-gift-wrap-line="true"] [headers="quantity"],
      [data-gift-wrap-line="true"] .cart-items__quantity,
      [data-gift-wrap-line="true"] .cart-item__quantity {
        visibility: hidden !important;
        pointer-events: none !important;
      }

      [data-gift-wrap-line="true"] quantity-selector-component,
      [data-gift-wrap-line="true"] cart-quantity-selector-component,
      [data-gift-wrap-line="true"] .quantity-selector,
      [data-gift-wrap-line="true"] .gift-wrap-fixed-quantity,
      [data-gift-wrap-line="true"] .cart-items__remove {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
  }

  async function getCart() {
    const response = await fetch(`${routesRoot}cart.js`, {
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) throw new Error('Could not load cart');
    return response.json();
  }

  async function updateCartAttributes(enabled) {
    const response = await fetch(`${routesRoot}cart/update.js`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [attributeName]: enabled ? enabledValue : '',
        },
      }),
    });

    if (!response.ok) throw new Error('Could not update gift wrap attribute');
    return response.json();
  }

  async function addGiftWrap() {
    const response = await fetch(`${routesRoot}cart/add.js`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{ id: giftWrapVariantId, quantity: 1 }],
      }),
    });

    if (!response.ok) throw new Error('Could not add gift wrapping');
    return response.json();
  }

  async function changeGiftWrapQuantity(itemKey, quantity) {
    const response = await fetch(`${routesRoot}cart/change.js`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id: itemKey, quantity }),
    });

    if (!response.ok) throw new Error('Could not update gift wrapping');
    return response.json();
  }

  async function removeGiftWrap(giftWrapItems) {
    await Promise.all(giftWrapItems.map((item) => changeGiftWrapQuantity(item.key, 0)));
    await updateCartAttributes(false);
  }

  async function setGiftWrap(enabled) {
    const cart = await getCart();
    const giftWrapItem = getGiftWrapItem(cart);
    const giftWrapItems = getGiftWrapItems(cart);

    if (enabled) {
      if (!hasPurchasableItems(cart)) {
        await removeGiftWrap(giftWrapItems);
        updateCartBubble(0);
        return;
      }

      if (giftWrapItem) {
        if (giftWrapItem.quantity !== 1) {
          await changeGiftWrapQuantity(giftWrapItem.key, 1);
        }
      } else {
        await addGiftWrap();
      }

      await updateCartAttributes(true);
      return;
    }

    await removeGiftWrap(giftWrapItems);
  }

  async function syncCheckbox() {
    const checkbox = getCheckbox();
    if (!checkbox) return;

    checkbox.disabled = true;

    try {
      const cart = await getCart();
      const giftWrapItem = getGiftWrapItem(cart);
      const giftWrapItems = getGiftWrapItems(cart);
      const attributeEnabled = cart.attributes?.[attributeName] === enabledValue;
      const hasOtherItems = hasPurchasableItems(cart);

      updateCartBubble(getPurchasableItemCount(cart));

      if (giftWrapItems.length && !hasOtherItems) {
        updateCartBubble(0);
        await removeGiftWrap(giftWrapItems);
        window.location.reload();
        return;
      }

      checkbox.checked = Boolean(giftWrapItem) || attributeEnabled;

      if (attributeEnabled && !giftWrapItem && hasOtherItems) {
        await setGiftWrap(true);
        window.location.reload();
        return;
      }

      if (giftWrapItem && giftWrapItem.quantity !== 1) {
        await changeGiftWrapQuantity(giftWrapItem.key, 1);
        window.location.reload();
        return;
      }
    } catch (error) {
      console.error(error);
    } finally {
      checkbox.disabled = false;
      lockGiftWrapQuantityControls();
    }
  }

  document.addEventListener(
    'change',
    async (event) => {
      const checkbox = event.target instanceof Element ? event.target.closest(checkboxSelector) : null;
      if (!(checkbox instanceof HTMLInputElement)) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const nextChecked = checkbox.checked;
      checkbox.disabled = true;

      try {
        await setGiftWrap(nextChecked);
        checkbox.checked = nextChecked;
        window.location.reload();
      } catch (error) {
        console.error(error);
        checkbox.checked = !nextChecked;
        checkbox.disabled = false;
      }
    },
    true
  );

  injectGiftWrapStyles();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCheckbox);
  } else {
    syncCheckbox();
  }

  document.addEventListener('cart:update', syncCheckbox);
  document.addEventListener('cart-update', syncCheckbox);
  window.addEventListener('pageshow', syncCheckbox);
  new MutationObserver(lockGiftWrapQuantityControls).observe(document.documentElement, { childList: true, subtree: true });
})();
